import React from 'react';
import { useMediaQuery } from '@material-ui/core';

const Logo = (props) => {
  const isMobile = useMediaQuery('(max-width:1280px)');
  
  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: '12px',
      flexDirection: isMobile ? 'column' : 'row'
    }}>
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '60px',
          height: '60px',
          flexShrink: 0,
          ...props.style
        }}
      >
        <img
          alt="Logo"
          src="/static/logo.png"
          style={{ 
            display: 'block', 
            width: '50px',
            height: '50px',
            objectFit: 'contain'
          }}
        />
      </div>
      {isMobile ? (
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          gap: '4px'
        }}>
          <span style={{ 
            fontSize: '16px', 
            fontWeight: '600',
            color: 'white',
            fontFamily: 'Roboto, sans-serif',
            textAlign: 'center'
          }}>
            ECOCAPE RECYCLING
          </span>
          <span style={{ 
            fontWeight: '400', 
            fontSize: '14px',
            color: 'white',
            fontFamily: 'Roboto, sans-serif'
          }}>
            (demo app)
          </span>
        </div>
      ) : (
        <span style={{ 
          fontSize: '20px', 
          fontWeight: '600',
          color: 'white',
          whiteSpace: 'nowrap',
          fontFamily: 'Roboto, sans-serif'
        }}>
          ECOCAPE RECYCLING <span style={{ fontWeight: '400', fontSize: '16px' }}>(demo app)</span>
        </span>
      )}
    </div>
  );
}

export default Logo;
